<template>
  <div>
    <component
      :is="loading ? PrmIconField : 'div'"
      :class="fieldProps?.class"
      :style="fieldProps?.style"
    >
      <PrmInputText
        :model-value="modelValue"
        :disabled="loading || disabled"
        :readonly="loading || readonly"
        :invalid="invalid || !!errorMessage"
        :placeholder="placeholder"
        :required="required"
        style="width: 100%"
        data-qa="input-text__input"
        @update:model-value="emit('update:modelValue', $event as string)"
        @change="emit('change', (($event as Event).target as HTMLInputElement).value)"
      />
      <PrmInputIcon
        v-if="loading"
        class="pi pi-spin pi-spinner"
      />
    </component>
    <span
      v-if="!!errorMessage"
      class="input-wrapper-error"
    >
      {{ errorMessage }}
    </span>
  </div>
</template>

<script lang="ts" setup>
import PrmIconField from '@NitrexGroup/primevue/iconfield';
import PrmInputIcon from '@NitrexGroup/primevue/inputicon';
import PrmInputText from '@NitrexGroup/primevue/inputtext';

import {
  HTMLProperties,
} from '../../types/props';

defineProps<{
  modelValue?: string | null,
  loading?: boolean,
  // is for convenience
  disabled?: boolean,
  // is for convenience
  invalid?: boolean,
  // is for convenience
  readonly?: boolean,
  placeholder?: string,
  errorMessage?: string,
  required?: boolean,
  fieldProps?: HTMLProperties,
}>();

const emit = defineEmits<{
  // fires on every key stroke
  (e: 'update:modelValue', value: string): void,
  // Fires when the value was changed. To understand when a value is considered,
  // changed, see:
  // https://developer.mozilla.org/en-US/docs/Web/API/HTMLElement/change_event#text_input_element
  (e: 'change', value: string | null | undefined): void,
}>();
</script>
